<template>
  <page-section :title="$t('Profiles_Locations_Title_LocationsHistory')">
    <rest-list :payload="fetchEndpoint" ref="rest-list">
      <rest-list-column-date
        v-if="selectedColumns.date"
        prop="create_time"
        :title="$t('Profiles_Locations_Field_Date')"
        :width="200"
      />

      <rest-list-column
        v-if="selectedColumns.location"
        prop="location_title"
        :title="$t('Profiles_Locations_Field_Location')"
        :sortable="false"
      />

      <rest-list-column-enum
        v-if="selectedColumns.enter_exit"
        prop="enter"
        :title="$t('Profiles_Locations_Field_EnterExit')"
        :enum="ProfileLocationsEnterExitLabels"
        :sortable="false"
      />

      <rest-list-column
        v-if="selectedColumns.address"
        prop="location_address"
        :title="$t('Profiles_Locations_Field_Address')"
        :sortable="false"
      />

      <rest-list-column-enum
        v-if="selectedColumns.type"
        prop="location_type"
        :title="$t('Profiles_Locations_Field_GeofenceIBeacon')"
        :enum="ProfileLocationsTypesLabels"
        :sortable="false"
      />

      <rest-list-column-enum
        v-if="selectedColumns.application"
        prop="application_id"
        :title="$t('Profiles_Locations_Field_Application')"
        :enum="applications"
        :translate="false"
        :width="200"
        :sortable="false"
      />

      <rest-list-column
        v-if="selectedColumns.device"
        prop="device_id"
        :title="$t('Profiles_Locations_Field_Device')"
        :route="rowClickDeviceIdRoute"
        :width="200"
        :sortable="false"
      />

      <el-table-column :width="50" align="center">
        <template slot="header" slot-scope="{}">
          <rest-list-column-settings
            storage-key="profiles-locations-list-columns"
            :title="$t('Profiles_Locations_Field_Settings')"
            :columns="columns"
            v-model="selectedColumns"
          />
        </template>
      </el-table-column>
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnSettings from '@/common/components/rest/RestListColumnSettings'
import RestApi from '@/core/services/RestApi'
import {
  ProfileLocationsEnterExitLabels,
  ProfileLocationsTypesLabels
} from '@/modules/profiles/enum/ProfileIdentifiersEnum'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'ProfileLocationsListTable',

  components: {
    PageSection,
    RestList,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnSettings
  },

  props: {
    profileId: {
      required: true
    }
  },

  mounted() {
    this.fetchApps()
  },

  data() {
    return {
      applications: {},
      selectedColumns: {},
      ProfileLocationsEnterExitLabels,
      ProfileLocationsTypesLabels
    }
  },

  computed: {
    columns() {
      return {
        date: {
          title: this.$t('Profiles_Locations_Field_Date'),
          defaultValue: true,
          validation: true
        },
        location: {
          title: this.$t('Profiles_Locations_Field_Location'),
          defaultValue: true,
          validation: true
        },
        enter_exit: {
          title: this.$t('Profiles_Locations_Field_EnterExit'),
          defaultValue: true,
          validation: true
        },
        type: {
          title: this.$t('Profiles_Locations_Field_GeofenceIBeacon'),
          defaultValue: true,
          validation: true
        },
        address: {
          title: this.$t('Profiles_Locations_Field_Address'),
          defaultValue: true,
          validation: true
        },
        application: {
          title: this.$t('Profiles_Locations_Field_Application'),
          defaultValue: true,
          validation: true
        },
        device: {
          title: this.$t('Profiles_Locations_Field_Device'),
          defaultValue: true,
          validation: true
        }
      }
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url:
          'location-hits?expand=location_title,location_type,location_address',
        params: {
          profile_id: this.profileId
        }
      })
    },

    fetchAppsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``
      })
    }
  },

  methods: {
    fetchApps() {
      RestApi(this.fetchAppsEndpoint)
        .then(({ data }) => {
          let apps = []
          if (data.applications) {
            apps = data.applications.map(item => {
              return { id: item.id, name: item.name }
            })
            this.setApplications(apps)
          }
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    setApplications(applications) {
      let apps = {}
      applications.forEach(app => {
        apps[app.id] = app.name
      })
      this.applications = apps
    },

    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfileLocationsListTable.vue